import { commonFilter } from './filter';

export default {
  pageName: 'feedsChatting',
  pageId: '20027',
  pagePath: '/opinion/chatting',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    C_keyword: {
      buttonId: '200270',
    },
    GPT_Get_Btn: {
      buttonId: '2002701',
    },
    GPT_Confirm: {
      buttonId: '2002702',
    },
    ...commonFilter,
  },
};
